import {useState} from "react";
import {useLocation} from "react-router-dom";
import {useMutation} from "@apollo/client";
import {
    Button,
    Dialog, DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from "@mui/material";

import {GET_ALL_CONTENT_DATA, MOVE_CONTENT_INFO} from "../../../queries/GraphQLQueries";
import CustomAlert from "../../CustomAlert";
import {useDialogNavigation} from "../../../hooks/useDialogNavigation";

export default function MoveContentInfoDialog() {
    const handleClose = useDialogNavigation();
    const {state} = useLocation();

    const [alertMessage, setAlertMessage] = useState(null);
    const {sourceNodeId, sourceNodeName, targetNodeId, targetNodeName} = state || {};

    const [moveContentInfoMutation] = useMutation(MOVE_CONTENT_INFO, {refetchQueries: [{query: GET_ALL_CONTENT_DATA}, 'GetAllContentData']});

    const handleCloseCustomAlert = () => setAlertMessage(null);

    const handleMove = () => {
        moveContentInfoMutation({
            variables: {
                contentInfoId: sourceNodeId,
                newParentContentFolderId: targetNodeId
            }
        }).then(() => handleClose())
        .catch((e) => {
            setAlertMessage({children: e?.message, severity: 'error'});
            return false;
        });
    }

    return (
      <>
          <Dialog open={true}>
              <DialogTitle>Move Content Definition</DialogTitle>

              <DialogContent>
                  <Typography variant={"body"}>{`This will move Content Definition '${sourceNodeName}' under '${targetNodeName}'. Are you sure you want to proceed?`}</Typography>
              </DialogContent>
              <DialogActions>
                  <Button onClick={handleClose}>Cancel</Button>
                  <Button onClick={handleMove}>Move</Button>
              </DialogActions>
          </Dialog>
          <CustomAlert alertMessage={alertMessage} handleCloseCustomAlert={handleCloseCustomAlert}/>
      </>
    );
}
